import axios from 'axios';

const canCreateNonBillableKeys = async (orgId: string): Promise<boolean> => {
  const {
    data: { canCreateNonBillableKeys: _canCreateNonBillableKeys },
  } = await axios.get(
    `/supra_system/subscriptions/canCreateNonBillableKeys/${orgId}`,
  );

  return _canCreateNonBillableKeys;
};

export default canCreateNonBillableKeys;
